// Public UploadThing CDN URL for a stored file key. Used to render
// `<img src>` / `<video src>` previews from a bare `uploadthingKey`.
export const uploadthingFileUrl = (key: string): string =>
  `https://utfs.io/f/${key}`;
